module.exports = __webpack_public_path__ + "img/email.c3249a11.png";